import {
  collection,
  addDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  Timestamp,
  limit,
} from "firebase/firestore";
import { db } from "./firebase";
import { Acesso, AcessoForm } from "@/types/acesso";

const COL = "acessos";

export async function registrarAcesso(dados: AcessoForm): Promise<string> {
  const ref = await addDoc(collection(db, COL), {
    ...dados,
    timestamp: serverTimestamp(),
  });
  return ref.id;
}

export async function listarAcessos(limite?: number): Promise<Acesso[]> {
  const q = limite
    ? query(collection(db, COL), orderBy("timestamp", "desc"), limit(limite))
    : query(collection(db, COL), orderBy("timestamp", "desc"));
  
  const snap = await getDocs(q);
  return snap.docs.map((d) => {
    const data = d.data();
    return {
      id: d.id,
      timestamp: (data.timestamp as Timestamp)?.toDate() ?? new Date(),
      cidade: data.cidade ?? "Desconhecida",
      estado: data.estado ?? "",
      pais: data.pais ?? "Brasil",
      ip: data.ip ?? "",
      userAgent: data.userAgent ?? "",
    } as Acesso;
  });
}

export async function obterEstatisticas() {
  const acessos = await listarAcessos();
  
  const porCidade: Record<string, number> = {};
  const porEstado: Record<string, number> = {};
  
  acessos.forEach((acesso) => {
    const cidadeKey = `${acesso.cidade}, ${acesso.estado}`;
    porCidade[cidadeKey] = (porCidade[cidadeKey] || 0) + 1;
    porEstado[acesso.estado] = (porEstado[acesso.estado] || 0) + 1;
  });
  
  return {
    total: acessos.length,
    porCidade,
    porEstado,
  };
}
